import { render, staticRenderFns } from "./AwardUpdate.vue?vue&type=template&id=d9ad1d6e"
import script from "./AwardUpdate.vue?vue&type=script&lang=ts"
export * from "./AwardUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports